import { Component, Input } from '@angular/core';

@Component({
  selector: 'icon-bell',
  imports: [],
  templateUrl: './icon-bell.component.html',
  styles: `.bell-icon {
      transition: transform 0.2s ease-in-out;
    }
    
    .bell-icon:hover {
      transform: rotate(15deg);
    }

    /* Animation de balancement pour les nouvelles notifications */
    .bell-icon.animate-ring {
      animation: ring 0.5s ease-in-out;
    }

    @keyframes ring {
      0%, 100% { transform: rotate(0deg); }
      25% { transform: rotate(15deg); }
      75% { transform: rotate(-15deg); }
    }`
})
export class IconBellComponent {
  @Input() size: number = 24;
}
